module.exports = __webpack_public_path__ + "static/img/k_piz.22bd7fe6.png";